import { useEffect } from 'react';

import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

import { ContentWrapper } from '@/components/DybrComponents/StyledServicePagesElements';
import { ArchiveSettings } from '@/scenes/User/Settings/Blog/ArchiveSettings';
import { BlogTitleSettings } from '@/scenes/User/Settings/Blog/BlogTitle';
import { CommunityPostSettings } from '@/scenes/User/Settings/Blog/CommunityPostSettings';
import { DesignsBlockSettings } from '@/scenes/User/Settings/Blog/DesignsBlock';
import { CrosspostSettings } from '@/scenes/User/Settings/SettingsCrosspost';
import { ChangeBlogSettings } from './ChangeBlogSettings';
import { DeleteBlogSettings } from './DeleteBlogSettings';

export function BlogSettingsScene() {
  useEffect(() => {
    document.title = `Настройки блога`;
  }, []);

  return (
    <ContentWrapper data-testid="common-settings">
      <BlogTitleSettings />
      <CommunityPostSettings />
      <DesignsBlockSettings />
      <ArchiveSettings />
      <CrosspostSettings />
      <ChangeBlogSettings />
      <DeleteBlogSettings />
    </ContentWrapper>
  );
}
